import { z } from 'zod';
// Login Validation Schema
export const loginSchema = z.object({
    email: z
        .string({
            required_error: 'Email is required',
            invalid_type_error: 'Email is required',
        })
        .nonempty('Email is required')
        .max(254, 'Email must not exceed 254 characters')
        .regex(/^\S+$/, 'Email must not contain spaces')
        .email('Please enter a valid email address'),
    password: z.string().min(1, 'Please enter a password'),
});

export type LoginFormData = z.infer<typeof loginSchema>;
